// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__W6hYx","more":"styles_more__X91Qq"};